export default "__VITE_ASSET__1dd88a60__"